import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Box, Tabs, Tab, Button, Paper, Typography, Pagination, Menu, MenuItem, styled } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import RoutineStyle from '../../../components/GlobalPolicies/RoutineUpload.module.css';
import { ArrowDropDownIcon } from '@mui/x-date-pickers/icons';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Filter from '../Filter/Filter';

interface ProjectManagementTabsProps {
  tabValue: string;
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[];
  counts: { All: number; Pending: number; Approved: number; Reverted: number };
  verticalTabValue?: string;
  verticalTabValueNew?: string;
  handleVerticalTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  verticalTabs: { label: string; value: string; subTabs?: { label: string; value: string }[] }[];
  // verticalTabValue?: string;

  isLoading: boolean;
  routineData: any[];
  filteredRoutineData: any[];
  paginatedData: any[];
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
  itemsPerPage: number;
  setOpenUpload: (open: boolean) => void;
  getFileImagePath: (doc_path: string) => string;
  handleViewClick: (id: any, file_name: string, function_l1: any, current_project: any, created_at: any, updated_at: any, updated_by: any, status: any, reason_to_approve: any, reason_to_revert: any) => void;
  management: string;
  handleApplyFilter?: (function_l1: string, function_l2: string, function_l3: string, function_l4: string) => void;
  level1?: boolean;
  functionL1?: any;
  functionL2?: any;
  functionL3?: any;
  functionL4?: any;
  question?: any;
  initialValues?: {
    l1?: string;
    l2?: string;
    l3?: string;
    l4?: string;
  };

}

const ProjectManagementTabs: React.FC<ProjectManagementTabsProps> = ({
  tabValue,
  handleTabChange,
  tabStatuses,
  counts,
  verticalTabValue,
  handleVerticalTabChange,
  verticalTabs,
  isLoading,
  routineData,
  filteredRoutineData,
  paginatedData,
  handleChangePage,
  itemsPerPage,
  setOpenUpload,
  getFileImagePath,
  handleViewClick,
  management,
  handleApplyFilter,
  level1,
  functionL1,
  functionL2,
  functionL3,
  functionL4,
  verticalTabValueNew,
  initialValues = {
    l1: '',
    l2: '',
    l3: '',
    l4: ''
  },
  question
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showSubTabs, setShowSubTabs] = useState(false);

  const apiManagement = localStorage.getItem('apiManagement') || '';
  // Check if management matches apiManagement
  const isManagementMatching = management === apiManagement;


  const open = Boolean(anchorEl);
  const isVerticalTabChange = useRef(false);


  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setShowSubTabs(!showSubTabs);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubTabClick = (event: React.SyntheticEvent, value: string) => {
    handleVerticalTabChange(event, value);
    handleClose();
  };

  const currentTab = verticalTabs.find(tab => tab.value === verticalTabValue);
  const isChangeManagement = currentTab?.label === "Change Management";

  const StyledTableRow = styled(Box)<{ status: string }>(({ status }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    boxShadow: `4px 0px 0px 0px ${status === 'Approved'
      ? '#058B2B'
      : status === 'Reverted'
        ? '#e53935'
        : status === 'Pending'
          ? '#FF5C00'
          : 'transparent'
      } inset`,
  }));

  const activeTabStyle = {
    backgroundColor: '#e5b61138 !important', // Change this to your desired active tab background color
    fontWeight: 'bold', // Change this to your desired active tab font weight
    color: '#000 !important',
    border: '1px solid #d7a833',
    opacity: '1 !important'

  };

  const getAppliedFilterString = (functionL1: string, functionL2: string, functionL3: string, functionL4: string): string => {
    const filters = [];
    if (functionL1) filters.push(`L1: ${functionL1}`);
    if (functionL2) filters.push(`L2: ${functionL2}`);
    if (functionL3) filters.push(`L3: ${functionL3}`);
    if (functionL4) filters.push(`L3: ${functionL4}`);
    return filters.join(', ');
  };

 const handleVerticalTabChangeWrapper = (event: SyntheticEvent, newValue: string) => {
  if (handleVerticalTabChange) {
    handleVerticalTabChange(event, newValue);
  }
  // No need to call handleApplyFilter here since parent handles it
};


  useEffect(() => {
    isVerticalTabChange.current = false;
  });



  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={tabValue}>
        <Box sx={{ display: "flex", justifyContent: "space-between", borderColor: "divider" }}>
          <Box className={RoutineStyle.tabs_routine}>
            <TabList

              onChange={handleTabChange}
              aria-label="SIPOC Tabs"
            >
              {tabStatuses.map((tab) => (
                <Tab
                  key={tab.value}
                  label={`${tab.label} (${counts[tab.value] || 0})`}
                  value={String(tabStatuses.indexOf(tab) + 1)} // Ensure the value matches the index
                  sx={{ textTransform: 'none', fontWeight: '400' }}
                />
              ))}
            </TabList>
            <Button
              variant="contained"
              className={RoutineStyle.uploadBtn}
              onClick={() => setOpenUpload(true)}
              disabled={!isManagementMatching} // Disable button if management doesn't match
            >
              Upload
            </Button>
          </Box>
        </Box>

        <TabPanel value={tabValue} >
          <Box sx={{ display: "flex" }}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={verticalTabValue}
              onChange={handleVerticalTabChangeWrapper}
              aria-label="Vertical Tabs"
              sx={{ minWidth: "150px" }}
              className="vertical_rTabs"
            >
              {verticalTabs.map((tab) => (
                <React.Fragment key={tab.value}>
                  <Tab
                    label={
                      tab.label === "Change Management" ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {tab.label}
                          {showSubTabs ? (
                            <ArrowDropUpIcon sx={{ ml: 1 }} />
                          ) : (
                            <ArrowDropDownIcon sx={{ ml: 1 }} />
                          )}
                        </Box>
                      ) : (
                        tab.label
                      )
                    }
                    value={tab.value}
                    onClick={tab.label === "Change Management" ? handleClick : (event) => handleVerticalTabChange(event, tab.value)}
                    sx={verticalTabValue === tab.value ? activeTabStyle : {}}
                  />
                  {tab.label === "Change Management" && showSubTabs && tab.subTabs?.map((subTab) => (
                    <Tab
                      key={subTab.value}
                      label={subTab.label}
                      value={subTab.value}
                      sx={{ pl: 4, ...(verticalTabValue === subTab.value ? activeTabStyle : {}) }} // Indent sub-tabs and apply active style
                      onClick={(event) => handleSubTabClick(event, subTab.value)}
                    />
                  ))}
                </React.Fragment>
              ))}
            </Tabs>
            <Menu
              id="change-management-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'change-management-button',
              }}
              sx={{
                '& .MuiPaper-root': {
                  minWidth: "150px",
                  boxShadow: 'none',
                  border: '1px solid #e0e0e0',
                },
                '& .MuiMenuItem-root': {
                  padding: '10px 16px',
                  fontSize: '14px',
                  color: '#000',
                },
              }}
            >
              {verticalTabs.find(tab => tab.label === "Change Management")?.subTabs?.map((subTab) => (
                <MenuItem key={subTab.value} onClick={(event) => handleSubTabClick(event, subTab.value)}>
                  {subTab.label}
                </MenuItem>
              ))}
            </Menu>

            {isLoading ? (
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: "center",
                  backgroundColor: "transparent",
                  height: "600px",
                  pt: 0,
                }}
              >
                <Typography className={RoutineStyle.noFileText}>
                  Fetching Files...
                </Typography>
              </Paper>
            ) : (
              <Box sx={{ marginLeft: 2, flexGrow: 1 }}>
                <Paper
                  elevation={0}
                  sx={{
                    // p: 4,
                    // textAlign: "center",
                    backgroundColor: "transparent",
                    height: "600px",
                    pt: 0,
                  }}
                >

                  <Box
                    className='routineHeader'
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      // mb: 3,
                      // backgroundColor: '#fff',
                      // padding: 2,
                      // borderRadius: '11px',
                    }}
                  >
                    <Box>
                      <Typography className={RoutineStyle.routineHeading}>
                        {/* {currentTab?.label} */}
                        {/* {isChangeManagement && ` - ${verticalTabs.find(tab => tab.value === verticalTabValue)?.label}`} */}
                        {verticalTabValueNew}
                      </Typography>

                      <Typography sx={{ color: '#000', fontSize: '16px', pb: 2 }}>
                        {question}
                      </Typography>
                    </Box>

                    {level1 && (
                      <Filter
                        levels={1}
                        onApplyFilter={handleApplyFilter || (() => { })}
                        initialValues={{
                          l1: functionL1 || '',
                          l2: '',
                          l3: '',
                          l4: ''
                        }}
                      />
                    )}

                  </Box>



                  <Box sx={{ textAlign: 'left', py: 2 }}>
                    <Typography component="span" sx={{ color: '#696969' }}>
                      Filter:&nbsp;&nbsp;
                    </Typography>
                    <Typography component="span" sx={{ fontWeight: 600 }}>
                      {/* show here applied filter value seprated by comma */}
                      {getAppliedFilterString(functionL1, functionL2, functionL3, functionL4)}

                    </Typography>
                  </Box>


                  {counts[tabStatuses[Number(tabValue) - 1].value] === 0 ? (
                    <Typography className={RoutineStyle.noFileText}>
                      File not found for the selected status.
                    </Typography>
                  ) : filteredRoutineData.length > 0 ? (
                    <>
                      {paginatedData && paginatedData.length > 0 ? (
                        paginatedData.map((item) => (

                          <StyledTableRow sx={{ mb: 2 }} status={item.status}>
                            <Paper key={item.id} className={RoutineStyle.bordercard} sx={{ width: '100%' }}>
                              {/* First Row with File Icons */}
                              <Box sx={{ display: "flex", gap: "10px", p: 2, justifyContent: 'space-between', minWidth: '100%', }}>
                                {item.files && item.files.length > 0 ? (
                                  item.files.slice(0, 3).map((file: { doc_path: string; file_name: string; file_size: any; }, index: React.Key | null | undefined) => (
                                    <div key={index} style={{ display: "flex", textAlign: "left", gap: "5px", justifyContent: 'space-between' }}>
                                      <div>
                                        <img src={getFileImagePath(file.doc_path)} alt="File" height={50} width={50} />
                                      </div>
                                      <div>
                                        <p>{file.file_name.split("_").slice(-1).join("_")}</p>
                                        <h4>{file.file_size || "Unknown Size"}</h4>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <p>No files available</p>
                                )}
                              </Box>

                              <hr />

                              {/* Second Row with Other Data */}
                              <Box sx={{ display: "flex", p: 2 }}>
                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Name of the project</h4>
                                  <p>{item.current_project}</p>
                                </div>
                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Function L1</h4>
                                  <p>{item.function_l1 || "No function available"}</p>
                                </div>
                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Create Date</h4>
                                  <p>{new Date(item.created_at).toLocaleDateString()}</p>
                                </div>
                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Status</h4>
                                  <p
                                    className={RoutineStyle.statuspending}
                                    style={{
                                      color:
                                        item.status === 'Reverted'
                                          ? '#F00'
                                          : item.status === 'Approved'
                                            ? '#058B2B'
                                            : item.status === 'Pending'
                                              ? '#FF5C00'
                                              : '#000',
                                    }}
                                  >
                                    {item.status || "No status available"}
                                  </p>
                                </div>
                              </Box>

                              {/* Approved and Reverted Reason */}
                              {(item.status === "Approved" || item.status === "Reverted") && (
                                <Box sx={{ padding: '10px' }}>
                                  <Paper
                                    elevation={1}
                                    sx={{
                                      textAlign: 'left',
                                      borderRadius: '6px',
                                      border: `1px solid ${item.status === 'Reverted' ? 'red' : '#058B2B'}`,
                                      backgroundColor: item.status === 'Reverted' ? '#ffebeb' : '#e6ffed',
                                      padding: '10px',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: item.status === 'Reverted' ? 'red' : '#058B2B',
                                      }}
                                    >
                                      {item.status === "Approved" ? "Approved Reason" : "Reverted Reason"}
                                    </Typography>
                                    <Typography sx={{ paddingTop: '6px' }}>
                                      {item.status === "Approved" ? item.reason_to_approve : item.reason_to_revert}
                                    </Typography>
                                  </Paper>
                                </Box>
                              )}

                              <Box sx={{ display: "flex", justifyContent: "flex-end", padding: "10px", borderRadius: "9px" }}>
                                <Button onClick={() => handleViewClick(item.id, item.files[0]?.file_name, item.function_l1, item.current_project, item.created_at, item.updated_at, item.updated_by, item.status, item.reason_to_approve, item.reason_to_revert)} className={RoutineStyle.black_btn}>
                                  View
                                </Button>
                              </Box>
                            </Paper>
                          </StyledTableRow>

                        ))
                      ) : (
                        <p>No data available</p>
                      )}

                      {/* Pagination */}
                      {routineData.length > 3 && (
                        <Pagination
                          color="primary"
                          count={Math.ceil(routineData.length / itemsPerPage)}
                          onChange={handleChangePage}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,
                            "& .MuiPaginationItem-root": {
                              color: "black",
                            },
                            "& .MuiPaginationItem-ellipsis": {
                              color: "black",
                            },
                            "& .MuiPaginationItem-icon": {
                              color: "black",
                            },
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <Typography className="routinePara" variant="body1" gutterBottom>
                      <Typography className={RoutineStyle.noFileText}>
                        There's no file uploaded right now
                      </Typography>
                      Upload relevant documents as per the requirements.
                      <Button
                        variant="contained"
                        className={RoutineStyle.border_btn}
                        onClick={() => setOpenUpload(true)}
                        disabled={!isManagementMatching} // Disable button if management doesn't match

                      >
                        Upload
                      </Button>
                    </Typography>
                  )}
                </Paper>
              </Box>
            )}
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default ProjectManagementTabs;